import * as swcHelpers from '@swc/helpers';

const steps = {
    where: 0,
    what: 1,
    when: 2,
    who: 3
};
const mapStepToRoute = Object.keys(steps).reduce((obj, key)=>swcHelpers.objectSpread({}, obj, {
        [steps[key]]: key
    })
, {});

export { mapStepToRoute, steps };
//# sourceMappingURL=steps.js.map
